import * as React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { usePageType, useTranslate } from "hooks";
import type { LeftSidebarAcitveButton } from "interfaces/shared.types";
import s from "./LeftSidebar.module.scss";
import { Icon } from "../Icon/Icon";

type LeftSidebarButtonProps = {
  activeButton: LeftSidebarAcitveButton;
  setActiveButton: React.Dispatch<
    React.SetStateAction<null | LeftSidebarAcitveButton>
  >;
  currentPageButton: LeftSidebarAcitveButton | null;
  item: LeftSidebarAcitveButton;
};

export const LeftSidebarButton = Scrivito.connect(
  ({
    activeButton,
    currentPageButton,
    item,
    setActiveButton,
  }: LeftSidebarButtonProps) => {
    const translate = useTranslate();
    const activeButtonTitle = activeButton?.title;
    const currentPageButtonTitle = currentPageButton?.title;

    const { iconName, title, refProp } = item;

    const pageType = usePageType();
    const isPageFromActiveButton =
      activeButtonTitle === title &&
      pageType &&
      activeButton?.pageTypes?.includes(pageType);

    const isSupportPage = pageType === "ConfiguratorSupport";

    const handleBtnClick = () => {
      setActiveButton((prev) => {
        const activeButtonWithFirstLevel = {
          ...item,
          subNavLevel: { value: 0 },
        };
        if (prev?.title === title) {
          if (prev?.subNavLevel?.value ?? 0 > 0) {
            return activeButtonWithFirstLevel;
          }
          return null;
        }

        return activeButtonWithFirstLevel;
      });
    };

    if (refProp === "configLeftSidebarSupportRefs") {
      const supportObj = Scrivito.Obj.where(
        "_objClass",
        "equals",
        "ConfiguratorSupport",
      )
        .and("_path", "startsWith", "/")
        .first();

      if (!supportObj) {
        return null;
      }

      return (
        <Scrivito.LinkTag
          data-testid={`LeftSidebarButton_${iconName}-link`}
          to={supportObj}
          onClick={(e: React.MouseEvent) => {
            if (isSupportPage) {
              e.preventDefault();
            }
          }}
          className={cx(
            "p-0 border-0 d-flex flex-column align-items-center justify-content-center" +
              " cursor-pointer flex-shrink-0",
            s.leftSidebarButton,
          )}
        >
          <Icon iconName={iconName} className="icon-40 mb-1" />
        </Scrivito.LinkTag>
      );
    }

    return (
      <button
        data-testid={`LeftSidebarButton_${iconName}-link`}
        className={cx(
          "p-0 border-0 w-100 d-flex flex-column align-items-center justify-content-center" +
            " cursor-pointer flex-shrink-0",
          s.leftSidebarButton,
          {
            [s.leftSidebarButtonFocused]:
              activeButtonTitle === title || isPageFromActiveButton,
            [s.leftSidebarButtonActive]: currentPageButtonTitle === title,
          },
        )}
        key={title}
        onClick={handleBtnClick}
      >
        <Icon iconName={iconName} className="icon-40 mb-1" />
        <span className="text-uppercase mb-0 fw-bolder">
          {translate(title)}
        </span>
      </button>
    );
  },
);
